<template>
  <div class v-if="moneyRequests.length>0">
    <v-toolbar class="mb-3" elevation="0">
      <v-toolbar-title>Demande de fonds</v-toolbar-title>
    </v-toolbar>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-data-table :items="moneyRequests" :headers="headers">
            <template v-slot:item.user_id="{item}">{{item.user.firstname}} {{item.user.lastname}}</template>
            <template v-slot:item.amount="{item}">{{$format.money(item.amount)}}</template>
            <template v-slot:item.status="{item}">
              <v-chip :color="getStatus(item.status).color">{{getStatus(item.status).text}}</v-chip>
            </template>
            <template v-slot:item.actions="{item}">
              <v-dialog v-model="viewDialog[item.id]" max-width="450px">
                <template v-slot:activator="{on}">
                  <v-btn icon small v-on="on">
                    <v-icon>mdi-dots-horizontal</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>Detail de la demande</v-card-title>
                  <v-card-text>
                    <v-alert type="error" v-if="error">{{error}}</v-alert>
                    <v-row>
                      <v-col col="12">{{item.user.firstname}} {{item.user.lastname}}</v-col>
                    </v-row>
                    <v-row>
                      <v-col col="12">{{$format.money(item.amount)}}</v-col>
                    </v-row>
                    <v-row>
                      <v-col col="12">{{item.comment}}</v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn class="themed" small @click="viewDialog[item.id]=false">Annuler</v-btn>
                    <v-spacer />
                    <v-btn
                      class="themed"
                      @click="submitDecline(item)"
                      v-if="item.status =='asked'"
                    >Refuser</v-btn>
                    <v-btn
                      class="themed"
                      @click="submitAccept(item)"
                      color="primary"
                      v-if="item.status =='asked'"
                    >Accepter</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data: () => ({
    viewDialog: {},
    error: null,
    headers: [
      { text: "Date", value: "date" },
      { text: "Collaborateur", value: "user_id" },
      { text: "Montant", value: "amount" },
      { text: "Status", value: "status" },
      { text: "Actions", value: "actions" }
    ]
  }),
  computed: {
    ...mapGetters("moneyRequest", ["moneyRequests"])
  },
  mounted() {
    this.initialize();
  },
  methods: {
    ...mapActions("moneyRequest", ["list", "accept", "decline"]),
    initialize() {
      this.list();
    },
    submitDecline(request) {
      this.error = null;
      this.accept(request.id)
        .then(data => {
          request.status = data.status;
          this.viewDialog[request.id] = false;
        })
        .catch(error => {
          this.error = error.error;
        });
    },
    submitAccept(request) {
      this.error = null;
      this.accept(request.id)
        .then(data => {
          request.status = data.status;
          this.viewDialog[request.id] = false;
        })
        .catch(error => {
          this.error = error.error;
        });
    },
    getStatus(status) {
      if (status == "asked") {
        return {
          text: "Ouvert",
          color: "green"
        };
      } else {
        return {
          text: "Fermé",
          color: "grey"
        };
      }
    }
  }
};
</script>

<style>
</style>